import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { uniqueId } from 'lodash';

import blackMagnifier from '@images/black_magnifier.svg';

import * as styles from './search-input.module.scss';

export const SearchInput = ({ value, onChange, placeholder = 'Search' }) => {
  const [id] = useState(() => uniqueId('input-'));
  return (
    <div className={styles.wrapper}>
      <input
        value={value}
        type="text"
        id={id}
        placeholder={placeholder}
        className={styles.searchInput}
        onChange={(e) => onChange(e.target.value)}
        required
      />
      <label htmlFor={id}>{placeholder}</label>
      <img loading="lazy" src={blackMagnifier} alt="black magnifier" className={styles.magnifier} />
    </div>
  );
};

SearchInput.propTypes = {
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
};
